import { useCallback } from 'react';
import { useAppClockService } from '@mews/framework';
import { ReservationLinkResult, ReservationTimeState } from '@mews-commander/data-access';

const getReservationSortValue = (r: ReservationLinkResult, now: number) => {
    if (r.reservationTimeState === ReservationTimeState.CheckedIn) {
        return Number.MAX_SAFE_INTEGER;
    } else if (r.reservationTimeState === ReservationTimeState.ToBeCheckedIn) {
        return Number.MAX_SAFE_INTEGER - 1;
    }

    const diff = new Date(r.reservationStartUtc).valueOf() - now;

    return diff > 0 ? Number.MAX_SAFE_INTEGER - diff : diff;
};

export const useSortReservationForLinking = () => {
    const appClockService = useAppClockService();
    const now = appClockService.getValue();

    return useCallback(
        (a: ReservationLinkResult, b: ReservationLinkResult) =>
            getReservationSortValue(b, now) - getReservationSortValue(a, now),
        [now]
    );
};
